import { HTMLProps } from 'react';

type Position = 'left' | 'center' | 'right' | 'between' | 'around';
type Align = 'start' | 'center' | 'end';

type Props = {
  position?: Position;
  align?: Align;
  gap?: number;
} & HTMLProps<HTMLDivElement>;

const justifyContent: Record<Position, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  between: 'space-between',
  around: 'space-around',
};

const alignItems: Record<Align, string> = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

const Group: React.FC<Props> = ({
  position = 'left',
  align = 'center',
  style,
  gap,
  ...props
}) => {
  const styleProp: typeof style = {
    ...style,
    display: 'flex',
    justifyContent: justifyContent[position],
    alignItems: alignItems[align],
    gap,
  };

  return <div {...props} style={styleProp} />;
};

export default Group;
